import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { ephemeralFiltersMap } from '../state';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      ephemeralFilters: (_, { variables }) => {
        const input = (
          variables as { input?: { collectionId?: string; userId?: string } }
        )?.input;
        return ephemeralFiltersMap.get(
          `${input?.userId}-${input?.collectionId}`
        );
      },
    },
  },
};
